/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Motivation_WordsInputs */

const en_us2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivation reason why`)
};

const pt_br2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivacao motivo`)
};

const es_419_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivacion motivo razon`)
};

const pt_pt2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivacao motivo razao`)
};

const fr_fr2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivation raison pourquoi`)
};

const de_de2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivation grund warum`)
};

const it_it2_search_field_motivation_words = /** @type {(inputs: Search_Field_Motivation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivazione motivo perche`)
};

/**
* | output |
* | --- |
* | "motivation reason why" |
*
* @param {Search_Field_Motivation_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_motivation_words = /** @type {((inputs?: Search_Field_Motivation_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Motivation_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_motivation_words(inputs)
	if (locale === "es-419") return es_419_search_field_motivation_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_motivation_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_motivation_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_motivation_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_motivation_words(inputs)
	return en_us2_search_field_motivation_words(inputs)
});
export { search_field_motivation_words as "search.field_motivation_words" }